import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import avatar from '../assets/images/Larisa_Jahan_Khan.jpeg';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
        <img src={avatar} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/LarisaJahanKhan" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/larisajahankhan/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Larisa Jahan Khan</h1>
          <p>Emerging STEM Student with Excellence in Olympiad and Quizzes | Winner of Regional and National Science Competitions | Dedicated to Educational Outreach</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/LarisaJahanKhan" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/larisajahankhan/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;